<template>
  <!-- 社会治理 -->
  <section class="sectionBox griddingindex">
    <!-- 左侧导航栏 -->
    <div class="left_box"
         style="width:220px">
      <el-menu :router="true"
               class="el-menu-vertical-demo"
               background-color="#014f86"
               text-color="#fff"
               unique-opened
               active-text-color="#0074ff">
        <!-- 1 -->
        <template v-for="i in menu">
          <el-submenu v-if="i.children && i.children.length>0"
                      :index="''+i.id"
                      :key="i.id">
            <template slot="title">
              <span style="color:#fff">{{i.title}}</span>
            </template>
            <!-- 子选项 -->
            <template v-for="j in i.children">
              <el-submenu :index="''+j.id"
                          v-if="j.children && j.children.length>0"
                          :key="j.id">
                <template slot="title">{{j.title}}</template>
                <!-- <el-menu-item
                                    v-for="k in j.children"
                                    :key="k.id"
                                    :index="k.path"
                                >{{k.title}}</el-menu-item>-->
                <template v-for="k in j.children">
                  <el-submenu :index="''+k.id"
                              v-if="k.children && k.children.length>0"
                              :key="k.id">
                    <template slot="title">{{k.title}}</template>
                    <el-menu-item v-for="l in k.children"
                                  :key="l.id"
                                  :index="l.path">{{l.title}}</el-menu-item>
                  </el-submenu>
                  <el-menu-item v-else
                                :key="k.id"
                                :index="k.path">{{k.title}}</el-menu-item>
                </template>

              </el-submenu>
              <el-menu-item v-else
                            :key="j.id"
                            :index="j.path">{{j.title}}</el-menu-item>
            </template>
          </el-submenu>
          <el-menu-item v-else
                        :key="i.id"
                        :index="i.path">{{i.title}}</el-menu-item>
        </template>
      </el-menu>
    </div>
    <!-- 右侧内容区域 -->
    <div class="right_box"
         style="width:calc(100% - 220px);margin-left:220px">
      <transition name="mains"
                  enter-active-class="animated bounce">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      menu: []
      // Admin: "Admin"
    };
  },
  methods: {},
  computed: {
    // menu() {
    //    console.log('=>',[this.$store.state.menu.find(item=>item.path=='oldManFile')]);
    //   return [this.$store.state.menu.find(item=>item.path=='oldManFile')][0].children
      
    // }
  },
  
};
</script>
<style lang="less">
.griddingindex {
  .icon-bianji3 {
    color: #2e99cf;
  }
  .icon-shenhe {
    color: #ff04ed;
  }
  .icon-chakan {
    color: #199b5d;
  }
  .el-icon-delete {
    color: red;
  }
  .btn-footer {
    text-align: center;
  }
  .card-box,
  .listBox {
    height: 100%;
    width: 100%;
  }
}
.right_box_main{
  /*overflow-y:visible;*/
}
</style>